import React, { useCallback, useContext } from 'react';

import { BuildingFloorsContext } from '../../building-floors.context';
import BuildingsFloorsForm from '../Form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(BuildingFloorsContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <BuildingsFloorsForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
